import React from "react";
import { Hammer, Sofa, ChefHat, Bath, Box, ClipboardList } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { useReveal } from "../../hooks/useReveal";

const ICONS = [Hammer, Sofa, ChefHat, Bath, Box, ClipboardList];

const ServiceCard = ({ icon: Icon, title, description, index }) => {
  const { ref, inView } = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`service-card-${index}`}
      className={`fade-in-up ${inView ? "in-view" : ""} group bg-[#FAFAFA] border border-[#E5E5E5] p-8 md:p-10 transition-all duration-500 hover:bg-white hover:border-[#111]`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className="flex items-start justify-between mb-12">
        <Icon size={28} strokeWidth={1.25} className="text-[#111]" />
        <span className="font-mono-label text-[#999]">
          {String(index + 1).padStart(2, "0")}
        </span>
      </div>
      <h3 className="font-display text-2xl md:text-3xl text-[#111] mb-4">{title}</h3>
      <p className="text-[#555] leading-relaxed">{description}</p>
    </div>
  );
};

const Services = () => {
  const { t } = useLang();
  const items = t("services.items");

  return (
    <section id="servicios" data-testid="services-section" className="section-pad bg-[#FAFAFA]">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 lg:mb-24">
          <div className="lg:col-span-5">
            <div className="font-mono-label text-[#666] mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-[#A89F91]" />
              {t("services.kicker")}
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#111]">
              {t("services.title")}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-[#555] text-base md:text-lg leading-relaxed max-w-xl">
              {t("services.subtitle")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
          {Array.isArray(items) &&
            items.map((s, i) => (
              <ServiceCard
                key={i}
                icon={ICONS[i % ICONS.length]}
                title={s.title}
                description={s.description}
                index={i}
              />
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
